import SharedBenefit from '@/shared/models/Benefit'
export default class Benefit extends SharedBenefit {

}